import { DeliverableOperation } from "@shuttlerock/api-types/federated";
import { type OperationCheck, operationCheckPasses } from "@shuttlerock/utils";

type RevisionOperationCheck = OperationCheck<DeliverableOperation>;

export function createRevisionOperationCheckPasses(
  checks: readonly RevisionOperationCheck[] | null | undefined,
) {
  return operationCheckPasses(checks, DeliverableOperation.CreateRevision);
}

// Revision-request parity with project-review's deriveCanRequestRevision:
// change one, change both.
export function deriveCanRequestRevision({
  shouldCheckViewerOperation,
  canUpdateRevisions,
  viewerOperationChecks,
}: {
  shouldCheckViewerOperation: boolean;
  canUpdateRevisions?: boolean;
  viewerOperationChecks?: readonly RevisionOperationCheck[] | null;
}) {
  if (!canUpdateRevisions) {
    return canUpdateRevisions;
  }

  if (!shouldCheckViewerOperation) {
    return true;
  }

  return createRevisionOperationCheckPasses(viewerOperationChecks);
}
